<template>
  <div class="speed-test">
    <el-dialog title="网络检测" :visible.sync="speedOpen" width="500px" :close-on-click-modal="false">
        <div class="speed-test-gif" v-if="flag==1">
            <img src="~@/assets/imgs/speed-test.gif" class="gif" alt="">
        </div>
        <div class="speed-test-gif" v-else-if="flag==2" >
            <img src="~@/assets/imgs/signal1.png" alt="" class="png">
        </div>
        <div class="speed-test-gif" v-else-if="flag==3" >
            <img src="~@/assets/imgs/signal2.png" alt="" class="png">
        </div>
        <div class="speed-test-gif" v-else-if="flag==4">
            <img src="~@/assets/imgs/signal3.png" alt="" class="png">
        </div>
        <div class="speed-test-gif" v-else-if="flag==5">
            <img src="~@/assets/imgs/signal4.png" alt="" class="png">
        </div>
        <div class="speed-test-gif" v-else-if="flag==6">
            <img src="~@/assets/imgs/signal5.png" alt="" class="png">
        </div>
      <p class="test-speed1">{{title}}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handClick">{{btn}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { baseUrl } from '@/config/env'

export default {
  data() {
    return {
      flag:1,
      speedOpen: false,
      nowTime: null,
      strURL:'',
      bolIsRunning:false,
      arrDelays:[],
      intSent: 0,
      intLost:0,
      intTimerID:null,
      bolIsTimeout:false,
      objIMG:{},
      title:'',
      btn:'',
      timer:''
    }
  },
  created(){
    this.setStart()
  },
  watch: {
    speedOpen: {
      immediate: true,
      handler: function(newVal) {
        if (newVal) {
            this.handStart()
            this.title = '网络检测中...'
            this.flag = 1
            this.btn = '取消'
        }
      }
    }
  },
  methods: {
    changeVisible(visible = false) {
      this.speedOpen = visible
    },
    handClick(){
        this.speedOpen = false
        clearTimeout(this.timer);
        this.handEnd()
    },
    handEnd(){
        this.intRecv = this.arrDelays.length;
        this.intLost = this.intSent - this.intRecv;
        var sum = 0;
        for (var i = 0; i < this.intRecv; i++)
            sum += this.arrDelays[i];
        this.bolIsRunning = false;
        /*  * 统计结果  */
        // document.querySelector('.test-speed1').innerText = `发送:${this.intSent},接收:${this.intRecv},丢包:${this.intLost},丢包率:${Math.floor(this.intLost/this.intSent*100)}`
        // document.querySelector('.test-speed2').innerText = `最小速度:${Math.min.apply(this, this.arrDelays)}ms,最大速度:${Math.max.apply(this, this.arrDelays)}ms,平均速度:${Math.floor(sum / this.intRecv)}ms`
        let avg = Math.floor(sum / this.intRecv)
        if(this.intLost>0){
            this.title = "当前网络不可用!"
            this.flag = 2
            this.btn = '完成'
        }else if(avg>0 && avg<=30){
            this.title = "当前网络质量非常好!"
            this.flag = 6
            this.btn = '完成'
        }else if(avg>30 && avg<=50) {
            this.title = "当前网络质量良好!"
            this.flag = 5
            this.btn = '完成'
        }else if(avg>50 && avg<=100) {
            this.title = "当前网络质量一般!"
            this.flag = 4
            this.btn = '完成'
        }else if(avg>100 && avg<=200) {
            this.title = "当前网络质量较差!"
            this.flag = 3
            this.btn = '完成'
        }else if(avg>200){
            this.title = "当前网络不可用!"
            this.flag = 2
            this.btn = '完成'
        }
        // if (this.intRecv == 0) return;
    },
    handStart(){
        this.title = '测试过程大概需要30秒,请耐心等待!'
        this.strURL = baseUrl
        if (this.strURL.length == 0)
            return;
        // if (this.strURL.substring(0, 7).toLowerCase() != "http://")
            // this.strURL = "http://" + this.strURL;
        this.intTimeout = 1000;
        this.bolIsRunning = true;
        this.arrDelays = [];
        this.intSent = 0;
        this.ping();
        this.timer = setTimeout(()=>{this.handEnd()},30000)
    },
    setStart() {
      this.objIMG = new Image()
      this.objIMG.onload = this.objIMG.onerror = () => {
        /* * 有回应,取消超时计时 */
        clearTimeout(this.intTimerID)
        if (!this.bolIsRunning || this.bolIsTimeout) return
        var delay = new Date() - this.intStartTime
        this.arrDelays.push(delay)
        /* * 每次请求间隔限制在1秒以上 */
        setTimeout(()=>{this.ping()}, delay < 1000 ? (1000 - delay) : 1000)
      }
    },
    ping() {
        this.intStartTime = +new Date()
        this.intSent++
        this.objIMG.src = this.strURL + '/' + this.intStartTime
        this.bolIsTimeout = false
        /* * 超时计时 */
        this.intTimerID = setTimeout(()=>{this.timeout}, this.intTimeout)
    },
    timeout() {
        if (!this.bolIsRunning) return
        this.bolIsTimeout = true
        this.objIMG.src = 'X:\\'
        this.ping()
      }
  }
}
</script>
<style lang="less" scoped>
.speed-test{
    .test-speed1{
        text-align: center;
    }
    .speed-test-gif{
        width: 460px;
        height: 150px;
        position: relative;
        .gif{
            width: 200px;
            position: absolute;
            top: 0;
            left: 230px;
            margin-left: -90px;
        }
        .png{
            width: 100px;
            position: absolute;
            bottom: 10px;
            left: 230px;
            margin-left: -50px;
        }
    }
}
</style>
<style lang="less">
.speed-test{
    .el-dialog__footer{
        text-align: center;
    }
}
    
</style>
